import { render } from "./Input.vue?vue&type=template&id=1a2cb2bb&ts=true"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__